import { useDispatch, useSelector } from "react-redux";
import { getCityLocalStorage, saveCityLocalStorage } from "../../../store/localStorage/city";
import { controlLoadingMap, setBusStaitionsOnMap, setBusStationsForm, setBusStationsFormTo, setBusStationsShippingFrom, setBusStationsShippingTo, setCities, setCitiesInit, setCitiesTo, setCity, setCityTo, setRoadmap, setRoadmaps, setViewPortMapMode } from "../store/mapScreenSlce";
import { ICity } from "@/shared/types/city";
import useMap from "./useMap";
import useBusstaitions from "./useBusstaitions";
import { IResponseGetCities } from "@/api/cityes/type";
import apiCities from "../../../api/cityes/apiCities";
import { useState } from "react";
import { RootState } from "@/store/redux/store";
import useRoadmaps from "./useRoadmaps";
import apiBusStations from "../../../api/busStaitions/apiBusStaitions";
import { format } from "path";
import { formatDateDDMMYYYY } from "../../../utils/dateFunctions";
import { getCitiesFrom, getCitiesTo } from "../../../services/GET_FROM_OR_TO/GET_FROM_OR_TO";

function useCity() {
    const dispatch = useDispatch();
    const { city, cityTo, cities, citiesInit, date } = useSelector((state: RootState) => state.mapScreen);
    const { changeStateAndZoomMap } = useMap();
    const { fillBusStations } = useBusstaitions();
    const [isLoadingCities, setIsLoading] = useState<boolean>(false);

    function initCity(): Promise<ICity> {
        let city = getCityLocalStorage();
        console.log('есть сохраненный город', city)
        dispatch(setCity(city));
        return Promise.resolve(city);
    }

    function selectCity(city: ICity | null, isFillstaitions: boolean = true) {
        if (!city) {
            saveCityLocalStorage(undefined);
            dispatch(setCity(undefined));
            dispatch(setBusStaitionsOnMap([]));
            dispatch(setRoadmaps([]));
            dispatch(setRoadmap(undefined));
            return;
        }
        saveCityLocalStorage(city);
        dispatch(setCity(city));
        dispatch(setViewPortMapMode('centerChange'))
        changeStateAndZoomMap([city.center_x_coord, city.center_y_coord], 12)
    }

    function selectCityTo(city: ICity, isFillstaitions: boolean = true) {
        dispatch(setCityTo(city));
        if (!city) {
            dispatch(setBusStationsShippingTo([]));
        }
    }

    function fillCities(response: IResponseGetCities) {
        const cities = adapterCities(response.cities);
        return cities;
    }

    /** Получить список городов иницииации */
    async function getCities(value: string | undefined) {
        try {
            setIsLoading(true);
            dispatch(controlLoadingMap('cities'))
            //await fillCitiesFromAndTo();
            const response = await apiCities.getCities(
                { NFIRST_ROWNUM: 0, NLAST_ROWNUM: 20000, CFILTER: value ?? '', NID: null }
            );
            const cities = fillCities(response)
            dispatch(setCitiesInit(cities))
            setIsLoading(false);
            return cities;
        } catch (error) {
            console.error(error);
            setIsLoading(false);
        } finally {
            dispatch(controlLoadingMap('cities'));
        }
    }

    /** Получить нас пункты, в которые можно попасть из текущего */
    async function fetchCitiesShippingToCity(city?: ICity) {
        try {
            const dateDDMMYYYY = formatDateDDMMYYYY(date);
            dispatch(controlLoadingMap('citiesTo'));
            const res = await apiBusStations.getStaitionsOrCityShipping({
                CWHAT: 'ГОРОДА_КУДА',
                NLOCALITY_ID_FROM: city?.id.toString() ?? '',
                dDATE: dateDDMMYYYY,
            })
            return res.data;
        } catch (error) {

        } finally {
            dispatch(controlLoadingMap('citiesTo'));
        }
    }

    /** Получить нас пункты, в которые можно попасть из текущего */
    // async function fetchCitiesShippingToCity(city?: ICity) {
    //     try {
    //         dispatch(controlLoadingMap('citiesTo'));
    //         const res = await apiBusStations.getStaitionsOrCityShipping({
    //             CWHAT: 'ГОРОДА_ОТКУДА',
    //             NLOCALITY_ID_FROM: city?.id.toString() ?? '',
    //         })
    //         console.log('fetchCitiesShippingToCity res', res)
    //         return res.data;
    //     } catch (error) {

    //     } finally {
    //         dispatch(controlLoadingMap('citiesTo'));
    //     }
    // }

    /** Получить нас пункты, в которые можно попасть с остановки */
    async function fetchCitiesShippingFromStaition(staitionId: string) {
        try {
            dispatch(controlLoadingMap('citiesTo'));
            const dateDDMMYYYY = formatDateDDMMYYYY(date);
            const res = await apiBusStations.getStaitionsOrCityShipping({
                CWHAT: 'ГОРОДА_КУДА',
                NSTOPPOINT_ID_FROM: staitionId,
                dDATE: dateDDMMYYYY,
            })
            return res.data;
        } catch (error) {

        } finally {
            dispatch(controlLoadingMap('citiesTo'));
        }
    }

    //TODO вынести в отдельный хук по ГЕТ ОР ТУ
    function adaptAndFillCitiesTo(citiesTo) {
        return citiesTo;
        const citiesToAdapt = citiesTo.map((city) => {
            const cityFullInfo = citiesInit.find((c) => c.id.toString() === city.id.toString());
            return cityFullInfo;
        })

        return citiesToAdapt;
    }

    function adaptAndFillCities(cities) {

        // const citiesToAdapt = citiesTo.map((city) => {
        //     const cityFullInfo = init.find((c) => c.id.toString() === city.id.toString().replace(/\D+/g, ''));
        //     return cityFullInfo;
        // })

        return cities;
    }

    /** Наполнить нас пункты прибытия по нас пункту отправления */
    async function fillCitiesShippingFromCity(city?: ICity) {
        try {
            const cities = await fetchCitiesShippingToCity(city);
            const citiesAdapt = adaptAndFillCities(cities);
            dispatch(setCitiesTo(citiesAdapt));
        }
        catch (error) {
            console.error('Error fetching cities shipping from city:', error);
        }
    }

    /** Наполнить нас пункты отправления по нас пункту прибытия */
    async function fillCitiesShippingCity(cityTo?: ICity) {
        try {
            //const citiesTo = await fetchCitiesShippingToCity(city);
            const citiesFrom = await getCitiesFrom({ localityIdFrom: cityTo ? cityTo.id.toString() : '' })
            const citiesAdapt = adaptAndFillCities(citiesFrom);
            dispatch(setCities(citiesAdapt));

        }
        catch (error) {
            console.error('Error fetching cities shipping from city:', error);
        }
    }

    /** наполнить все города прибытия и отправления */
    async function fillAllCitiesShippingClear(city?: ICity) {
        try {
            //const citiesTo = await fetchCitiesShippingToCity(city);
            const cities = await getCitiesFrom({ localityIdTo: '' })
            const citiesTo = await getCitiesTo({ localityIdFrom: '' })
            const citiesToAdapt = adaptAndFillCitiesTo(citiesTo);
            const citiesFrom = adaptAndFillCitiesTo(cities);
            dispatch(setCitiesTo(citiesToAdapt));
            dispatch(setCities(citiesFrom));

        }
        catch (error) {
            console.error('Error fetching cities shipping from city:', error);
        }
    }

    /** Наполнить нас пункты отправоения и прыбтия */
    async function fillCitiesFromAndTo() {
        try {
            fillAllCitiesShippingClear();
        }
        catch (error) {
            console.error('Error fetching cities shipping from city:', error);
        }
    }

    /** Наполнить нас пункты прибытия по остановке отправления */
    async function fillCitiesShippingFromStaition(staitionId: string) {
        try {
            const citiesTo = await getCitiesTo({ stopPointIdFrom: staitionId })
            const adapt = adaptAndFillCitiesTo(citiesTo);
            dispatch(setCitiesTo(adapt));
        }
        catch (error) {
            console.error('Error fetching cities shipping from city:', error);
        }
    }

    /** Наполнить нас пункты отправления по остановке прибытия */
    async function fillCitiesShippingFromStaitionTO(staitionId: string) {
        try {
            const citiesFrom = await getCitiesFrom({ stopPointIdFrom: staitionId })
            const adapt = adaptAndFillCitiesTo(citiesFrom);
            dispatch(setCities(adapt));
        }
        catch (error) {
            console.error('Error fetching cities shipping from city:', error);
        }
    }

    return ({
        initCity,
        selectCity,
        selectCityTo,
        isLoadingCities,
        getCities,
        city,
        cityTo,
        cities,

        fillAllCitiesShippingClear,

        fillCitiesShippingFromCity,

        fillCitiesShippingFromStaitionTO,
        fillCitiesShippingFromStaition,

        fillCitiesFromAndTo,

        fillCitiesShippingCity
    })
}

export default useCity;


function adapterCities(cities: Record<string, ICity>): ICity[] {
    const citieKeys = Object.keys(cities);
    const updated = citieKeys.reduce((array: ICity[], key: string) => {
        array.push(cities[key]);
        return array;
    }, []);

    return updated;
}